/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/**
 *
 * TechnicalIntervention
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import injectSaga from 'utils/injectSaga';
import injectReducer from 'utils/injectReducer';
import _, { get, isEmpty } from 'lodash';
import ListManager from 'novigo-entity-grid';
import FormManager from 'novigo-form-manager';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { Header } from 'semantic-ui-react';
import { makeSelectImages } from './selectors';
import reducer from './reducer';
import saga from './saga';
import messages from './messages';
import appMessages from '../App/messages';
import actionToBreadcrumb from '../../utils/actionToBreadcrumb';
import { addNotification } from '../../utils/notification';
import attachmentService from '../../shared/services/attachments';
import StaffWorkorderAttachmentService from '../../shared/services/staffworkorderattachment';
import StaffWorkorderService from '../../shared/services/staffworkorder';
import { downloadFileFromAjaxResponse } from '../../utils/functions';
import { uploadImage } from './actions';
import { onCleanData, transformData } from './formHelper';
import PermissionManager from '../../components/Permission';
import { CanManage } from '../Can/utils';

/*
 * Specific import
 */

import { API } from '../../global-constants';

import request from '../../shared/services/request';

import { ListWrapper, Page } from '../../components/Layout';
import TechnicalInterventionForm, {
  validation,
} from '../../components/Forms/TechnicalInterventionForm';
import {
  RELATED_TABLES,
  StaffWorkorderColumns,
  StaffWorkorderFilters,
} from './tableHelper';
import TechnicalInterventionAssignmentForm from '../../components/Forms/TechnicalInterventionAssignmentForm';
export class TechnicalIntervention extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: false,
      showAssignForm: false,
      reloadIndex: 0,
    };
  }

  assignWorkorder() {
    this.setState({ showForm: false, showAssignForm: true });
  }

  closeModal() {
    this.setState({ showForm: false, showAssignForm: false });
  }

  evaluteAction() {
    if (
      this.props.match.params.action === 'view' ||
      this.props.match.params.action === 'delete' ||
      this.props.match.params.action === 'modify' ||
      this.props.match.params.id === 'new'
    ) {
      this.setState({ showForm: true, showAssignForm: false });
    } else {
      this.setState({ showForm: false, showAssignForm: false });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.evaluteAction();
    }
  }

  componentDidMount() {
    this.evaluteAction();
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.images === this.props.images;
  }

  transformData = data => transformData(data);

  handleUpload = id => {
    const { images } = this.props;
    if (images && images.length > 0) {
      const data = {
        entityType: `Fotografia_${id}`,
        entityId: id,
        entityName: 'StaffWorkorder',
        files: this.props.images,
      };
      attachmentService.uploadMultiple(data).then(res => {
        const attachmentId = [];
        const resArray = [Object.values(_.get(res, 'data', []))];
        resArray[0].map(arr => attachmentId.push(arr.result));
        StaffWorkorderAttachmentService.upload({
          attachmentId,
          staffWorkorder: id,
        });
      });
    }
    this.props.history.push(API.STAFF_WORK_ORDER);
  };

  exportPdf = id => {
    StaffWorkorderService.exportPdf(id)
      .then(response => {
        downloadFileFromAjaxResponse(response);
      })
      .catch(err => {
        addNotification({
          title: this.context.intl.formatMessage(appMessages.error),
          message: _.get(
            err,
            'data.detail',
            this.context.intl.formatMessage(appMessages.an_error_has_occurred),
          ),
          isError: true,
        });
      });
  };

  sendPdf = id => {
    StaffWorkorderService.sendPdf(id)
      .then(response => {
        addNotification({
          title: this.context.intl.formatMessage(appMessages.success),
          message: _.get(
            response,
            'data.message',
            this.context.intl.formatMessage(appMessages.success),
          ),
          isError: false,
        });
      })
      .catch(err => {
        addNotification({
          title: this.context.intl.formatMessage(appMessages.error),
          message: _.get(
            err,
            'data.detail',
            this.context.intl.formatMessage(appMessages.an_error_has_occurred),
          ),
          isError: true,
        });
      });
  };

  manageAction = (data, action) => {
    const routerManager = get(this.props, 'history');
    const routerPath = "staff-workorder";
    if (routerManager) {
      routerManager.push(`/${routerPath}/${data.id}/${action}`);
    } else {
      addNotification({
        title: this.context.intl.formatMessage(appMessages.error),
        message: this.context.intl.formatMessage(
          appMessages.an_error_has_occurred,
        ),
        isError: true,
      });
    }
  };

  onRemoveFilter = name => {
    if (name === 'startDate' || name === 'endDate') {
      // TODO manually manage the removal of these filters if possible
    }
  };

  canEdit = item => {
    const isAdmin = CanManage(this.props.user);
    if (item.state === "Chiuso" && !isAdmin) {
      addNotification({
        title: this.context.intl.formatMessage(appMessages.error),
        message: "L'intervento é chiuso, non é modificabile",
        isError: true,
      });
      return false;
    }
    return true;
  }

  render() {
    return (
      <>
        <Helmet>
          <title>{this.context.intl.formatMessage(messages.title)}</title>
          <meta
            name="description"
            content={this.context.intl.formatMessage(messages.title)}
          />
        </Helmet>
        <Page>
          <Header as="h2" dividing>
            <FormattedMessage {...messages.title} />
          </Header>
          {this.state.showAssignForm && (
            <>
              <BreadcrumbsItem to="/staff-workorder/assign">
                {actionToBreadcrumb({
                  action: this.props.match.params.action,
                  intl: this.context.intl,
                })}
              </BreadcrumbsItem>
              <TechnicalInterventionAssignmentForm
                {...this.props}
                history={this.props.history}
              />
            </>
          )}

          {this.state.showForm && (
            <>
              <BreadcrumbsItem to="/staff-workorder/edit">
                {actionToBreadcrumb({
                  action: this.props.match.params.action,
                  intl: this.context.intl,
                })}
              </BreadcrumbsItem>
              <FormManager
                key={this.props.match.params.action} // necessary to reload the current view upon redirect
                router={this.props} // necessary to use the internal routing
                afterCreate={res => this.handleUpload(res.id)}
                client={pars =>
                  request(pars).then(res => this.transformData(res.data))
                }
                mask={props => (
                  <TechnicalInterventionForm
                    {...this.props}
                    {...props}
                    editRoute={`/staff-workorder/${this.props.match.params.id
                      }/modify`}
                    showEditButton={false}
                    history={this.props.history}
                  />
                )}
                validation={validation}
                onCleanData={data => onCleanData(data)}
                entityName="staff-workorder"
                basePath={API.BASE_URL}
                permissions={this.props.user}
                afterUpdate={() => false}
                onError={data =>
                  addNotification({
                    title: this.context.intl.formatMessage(appMessages.error),
                    message: _.get(
                      data,
                      'detail',
                      this.context.intl.formatMessage(
                        appMessages.an_error_has_occurred,
                      ),
                    ),
                    isError: true,
                  })
                }
                onSuccess={() =>
                  addNotification({
                    title: this.context.intl.formatMessage(appMessages.success),
                    message: this.context.intl.formatMessage(
                      appMessages.operation_performed_successfully,
                    ),
                    isError: false,
                  })
                }
              />
            </>
          )}

          {!this.state.showForm &&
            !this.state.showAssignForm && (
              <>
                <ListWrapper>
                  <ListManager
                    basePath={API.BASE_URL}
                    canExport={{
                      exportLabelPrefix: this.context.intl.formatMessage(
                        appMessages.export_to,
                      ),
                    }}
                    onRemoveFilter={this.onRemoveFilter}
                    canSearchCustom={StaffWorkorderFilters(this.context.intl)}
                    canSelect={{
                      active: PermissionManager.CanI(
                        'read',
                        'technicalIntervention',
                      ),
                      selectAll: false,
                      actions: [
                        {
                          icon: 'user',
                          color: 'green',
                          label: this.context.intl.formatMessage(
                            messages.assign_workorder,
                          ),
                          onClick: () => this.assignWorkorder(),
                        },
                      ],
                    }}
                    client={pars => request(pars).then(res => res.data)}
                    columns={StaffWorkorderColumns(this.context.intl)}
                    canCreate={{
                      active: false,
                    }}
                    defaultActions={{
                      visualize: true,
                      modify: false,
                      delete: false,
                      grouped: false,
                      moreActions: [
                        {
                          icon: 'edit',
                          label: 'Modifica',
                          key: 'edit',
                          action: item => {
                            if (this.canEdit(item))
                              this.props.history.push(`${this.props.match.url}/${item.id}/modify`);
                          },
                        },
                        {
                          icon: 'trash',
                          label: 'Elimina',
                          key: 'elimina',
                          action: item => {
                            if (this.canEdit(item))
                              this.manageAction(item, 'delete');
                          },
                        },
                        {
                          icon: 'file pdf',
                          label: this.context.intl.formatMessage(
                            messages.export_pdf,
                          ),
                          key: 'export_pdf',
                          action: item => {
                            this.exportPdf(item.id);
                          },
                        },
                        {
                          icon: 'send',
                          label: this.context.intl.formatMessage(
                            messages.send_pdf,
                          ),
                          key: 'send_pdf',
                          action: item => {
                            this.sendPdf(item.id);
                          },
                        },
                      ],
                    }}
                    defaultOrder={[
                      {
                        type: 'field',
                        field: 'createdAt',
                        direction: 'desc',
                      },
                    ]}
                    entityName="staff-workorder"
                    locale={_.get(this.props, 'user.defaultLanguage', 'it')}
                    permissions={this.props.user}
                    ref={list => {
                      this.list = list;
                    }}
                    reloadIndex={this.state.reloadIndex}
                    router={this.props}
                    sessionKey="staff-workorder"
                    aliases={RELATED_TABLES}
                  />
                </ListWrapper>
              </>
            )}
        </Page>
      </>
    )
  }
}

TechnicalIntervention.propTypes = {
  user: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  images: makeSelectImages(),
});

function mapDispatchToProps(dispatch) {
  return {
    uploadImage: images => dispatch(uploadImage(images)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: 'workorder', reducer });
const withSaga = injectSaga({ key: 'technicalIntervention', saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(TechnicalIntervention);

TechnicalIntervention.contextTypes = {
  intl: PropTypes.object.isRequired,
};
